<template>
<b-row style='border: 1px solid black;border-radius: 5px; padding: 5px;margin: 5px;' >
<!--<div class='ticketDiv' >-->
    <b-col> 
        <div style="text-align: left" auto>
			<h4><b>{{ticket.siteName}}</b></h4><br>
			<b>Priority </b>: <br><span class='pull-left' v-bind:style="{'background-color': ticket.PriorityColour }" style='border: 1px solid black;border-radius: 5px; padding: 5px;color:white'>{{ticket.Name[2]}}</span><b-link :href="'https://energydrive.dnsalias.com/ticketcop/viewTicket/'+idTicket" target='_blank' style='color:inherit;'><span class='pull-right' v-bind:style="{'background-color': ticket.PriorityColour }" style='border: 1px solid black;border-radius: 5px; padding: 5px;color:white; float:right'>{{ticketState}} # 
                 {{idTicket}} </span></b-link><br><br>
			<!--<b>Ticket Tags:</b><br>
			<div class="ticketTag">
			<component-tagview :ticketid="idTicket" idticketcomment="-1" showadd="true"></component-tagview>
			</div><br><br>-->
			<b>Meter Accounts Linked to Ticket :</b> : <br>
            <span v-for="meterAccount in ticket.meterAccounts"  v-bind:key="meterAccount.idMeterAccount" >{{meterAccount.MeterAccountName}}<br></span>
			<br>
    
            <div v-if="ticket.CalcCost">
				<b>Financial Cost of Bypass :</b> <span style='color:#d04242'>{{ticket.TicketCost}}</span><br></div>
			<div v-else>
				<b>Financial Cost of Bypass :</b> <span>None</span><br></div>
			<b>Bypass Adjustment Fault  :</b>{{ticket.Name[0]}}<br>
			<br>
			<b>Category : </b>{{ticket.CatDesc[0]}}<br>
			<b>Sub Category : </b>{{ticket.CatDesc[1]}}<br>
			<b>Department</b> : {{ticket.Name[1]}}<br>
			<br>
			<b>Original Ticket Description</b> : <br>
			{{ticket.Description[0]}}<br>
            <div v-if="(ticket.comments)&& (ticket.comments.length >  0)">
                <!--<a href="#" onClick="return false;" data-toggle="collapse" :data-target="'#comment' + idTicket"><b>{{ticket.comments.length}} Comments (Click to show)</b></a>  <br>-->
               <!--<b-btn v-b-toggle="'comment'+ idTicket" class="m-1">{{ticket.comments.length}} Comments (Click to show)</b-btn> <br>-->
               <b-link v-b-toggle="'comment'+ idTicket" >{{ticket.comments.length}} Comments (Click to show)</b-link> <br>
            </div>
            <div v-else>
                <b>No Comments. </b><br>
            </div>
            <b-collapse :id="'comment' + idTicket" class="collapse">
                Comment History :<br><br>
                <div v-for="comment  in ticket.comments" v-bind:key="comment.idComment" style="border-style: solid;border-width:1px; border-radius: 4px;padding:5px;margin:5px">
                    <b>Comment Added by {{comment.CreatedBy}} on {{comment.CreatedDate}} </b><br>
                    {{comment.Comment}}<br>
                    <component-tagview :ticketid="idTicket" :idticketcomment="comment.idTicketHistory" :showadd="false"></component-tagview><br>
                    
                </div>
            </b-collapse>  
            <div v-if="(ticket.files)&&(ticket.files.length > 0)">
                <!--<a href="#" onClick="return false;" data-toggle="collapse" :data-target="'#files' + idTicket"><b>{{ticket.files.length}} Files Linked (Click to show)</b></a><br>-->
                <b-link v-b-toggle="'files'+ idTicket" @click="loadFiles()">{{ticket.files.length}} Files Linked (Click to show)</b-link> <br>
            </div>   
            <span v-if="ticket.files.length == 0"><b>No Files Linked</b></span><br>
            
            
            <b-collapse :id="'files' + idTicket" class="collapse">
                Files Linked :<br><br>
                <div v-for="file in ticket.files" v-bind:key="file.idTicket" style="border-style: solid;border-width:1px; border-radius: 4px;padding:5px;margin:5px">
                    <b-link @click="clickedLink(file.idTicketAttachment,'file'+file.idTicketAttachment,file.Extension)">

                    <img v-bind:src="file.imagePreview" v-show="file.showPreview" style="object-fit:cover;width:100%;height:100%" v-if="file.Extension=='jpg'||file.Extension=='png'"/><br>
                    <b>{{file.Description}} ({{file.type}})</b> Click to download<br></b-link>
                    Added by {{file.employee}} on {{file.createdDate}} <br>
                </div>
            
            </b-collapse>
            <br>
            <b>Supplies </b>: {{ticket.Supplies}}<br>
            <br>
            <b>Ticket Applies from </b>: {{ticket.TicketIssued}}<br>
            <span v-if="ticket.isJob"><b>Ticket Assigned to </b>: {{ticket.EmpUserE}}</span><br>
            <b>Ticket Generated by</b>: {{ticket.LoggerUserE}}<br>
            <div v-if="showListEmployeesTagged">
                <!--<a href="#" onClick="return false;" data-toggle="collapse" :data-target="'#comment' + idTicket"><b>{{ticket.comments.length}} Comments (Click to show)</b></a>  <br>-->
               <!--<b-btn v-b-toggle="'comment'+ idTicket" class="m-1">{{ticket.comments.length}} Comments (Click to show)</b-btn> <br>-->
               <b-link v-b-toggle="'subscribers'+ idTicket" >Ticket Subscribers (Click to show)</b-link> <br>
            </div>
            <b-collapse :id="'subscribers' + idTicket" class="collapse">
               <component-tagEmployee @updateEmployeeTagged="updateEmployeeTagged" :header="userTagHeader" :employeeTagged="employeeTagged" ></component-tagEmployee>
            </b-collapse>  
            <br>
            <div v-if="ticket.Resolved">
            
                <b>Resolved Comment</b>:{{ticket.ResolvedComment}}<br>
                <b>Resolved Date</b>:{{ticket.ResolvedDate}}<br>
                <b>Resolved By</b>:{{ticket.ResolveUserE}}<br>
                <br>
                <button class="btn btn-primary btnUnResolveTicket"  :data-idticket="idTicket" @click="unresolve">Unresolve Ticket</button>
                <!--<form action="unresolve" id="viewJob" method="get" class="col-xs-12 col-md-3" style="padding:0px;">
								
                                <input type="hidden" name="idTicket" :value="idTicket"></input>
                                <input type="hidden" name="url" value="viewTickets"></input>
                                <input type="submit" value="Unresolve Ticket" class="btn btn-primary" style="width:100%;">
                        
                </form>-->
            </div>
            <div v-else>
               <b-row >
                  
                    <!--<button class="btn btn-primary btnResolveTicket col-xs-12 col-md-3"  :data-idticket="idTicket">Resolve Job</button><div class="hidden-md hidden-lg"><br><br></div>-->
                    <b-col style="margin:1px;"><router-link :to="{ name: 'resolveJob', params: { idTicket: idTicket } }" tag="div" class="w-100">
                         <button class="btn btn-primary w-100">Resolve Job</button> </router-link>
                    </b-col >
                    <!--<form action="resolveTicket" id="viewJob" method="get" class="col-xs-12 col-md-3" style="padding:2px;">
								
                                <input type="hidden" name="idTicket" :value="idTicket"></input>
                                <input type="hidden" name="url" value="viewTickets"></input>
                                <input type="submit" value="Resolve Job" class="btn btn-primary" style="width:100%;">
                        
                    </form>-->
                    <!--<button class="btn btn-primary btnAddComment col-xs-12 col-md-3"  :data-idticket="idTicket">Add Comment</button><div class="hidden-md hidden-lg"><br><br></div>-->
                    <b-col><router-link :to="{ name: 'createComment', params: { idTicket: idTicket } }" tag="div" class="w-100">
                         <button class="btn btn-primary w-100">Comment</button> </router-link>
                    </b-col>
                    <!--<form action="addTicketComment" id="viewJob" method="get" class="col-xs-12 col-md-3" style="padding:2px;">
								
                                <input type="hidden" name="idTicket" :value="idTicket"></input>
                                <input type="hidden" name="url" value="viewTickets"></input>
                                <input type="submit" value="Add Comments" class="btn btn-primary" style="width:100%;">
                        
                    </form>-->
                    <b-col><router-link :to="{ name: 'assignJob', params: { idTicket: idTicket } }" tag="div" class="w-100">
                         <button class="btn btn-primary w-100">Assign Job</button></router-link>
                    </b-col>
                    <!--<form action="addReAssign" id="viewJob" method="get" class="col-xs-12 col-md-3" style="padding:2px;">
								
                                <input type="hidden" name="idTicket" :value="idTicket"></input>
                                <input type="hidden" name="url" value="viewTickets"></input>
                                <input type="submit" value="Assign Job" class="btn btn-primary" style="width:100%;">
                        
                    </form>-->
                    <br>
                    <b-col><router-link :to="{ name: 'addFile', params: { idTicket: idTicket } }" tag="div" class="w-100">
                        <button class="btn btn-primary w-100" >Attach File</button></router-link>
                    </b-col>
                    <!--<form action="addFile" id="viewJob" method="get" class="col-xs-12 col-md-3" style="padding:2px;">
								
                                <input type="hidden" name="idTicket" :value="idTicket"></input>
                                <input type="hidden" name="url" value="viewTickets"></input>
                                <input type="submit" value="Attach File" class="btn btn-primary" style="width:100%;">
                        
                    </form>-->
                    <!--<button class="btn btn-primary btnReAssign col-xs-12 col-md-3"  :data-idticket="idTicket">Assign Job</button><div class="hidden-md hidden-lg" @click="reassign"><br><br></div>-->
                    <!--<button class="btn btn-primary btnAddFile col-xs-12 col-md-3"  :data-idticket="idTicket">Attach File</button><div class="hidden-md hidden-lg"><br><br></div>-->
                    <b-modal ref="myModalRef" hide-footer title="Add Comment to Ticket">
                        <div class="d-block text-center">
                            <h3>Ticket #{{ticket.idTicket}}</h3>
                        </div>
                        <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-btn>
                    </b-modal>
                </b-row >
            </div>
        </div> 
    </b-col> 
<!--</div>  -->
</b-row >                     
</template>



<script type="text/javascript">
//const ActionButton = require('./ActionButton.vue');
import addTicketTag from './TagView.vue'
import axios from 'axios';
import tagEmp from '../components/tagEmployee.vue'

//module.exports = {
  export default {
    props: ['idTicket','ticket'], 
    components: {
    'component-tagview' : addTicketTag,
    'component-tagEmployee' : tagEmp
  },
  data: () => ({
      baseURL : "",
      ListEmployeeTagged : [],
      showListEmployeesTagged : false,
      employeeTagged : [],
      userTagHeader : "",
      ticketLink : "",
      filesLoaded : false

    
  }),
  methods: {
      submit : function() {
        console.log("Submit");
      },
      cancel : function() {
        console.log("Cancel");
      },
      loadFiles : function()
      {
          let objectMain = this;
          if ( !objectMain.filesLoaded )
          {
              for( let i = 0 ; i < objectMain.ticket.files.length ; i ++)
                {
                    //clickedLink(files[i].idTicketAttachment,'file'+files[i].idTicketAttachment,files[i].Extension
                    objectMain.loadimage(i);
                    
                }
                objectMain.filesLoaded = true;

          }
          else
          {
              console.log("Files already loaded");
          }
      },
      loadimage : function(i)
      {
          let objectMain = this;
          if ( objectMain.ticket.files[i].Extension=='jpg'||objectMain.ticket.files[i].Extension=='png')
          {
            axios({
                url: localStorage.getItem('ticketCopURL') +'/getFile',
                method: 'GET',
                responseType: 'blob', // important  
                //axios.get('https://energydrive.dnsalias.com/ticketcop_dev/viewJobs', {
                params: {
                    fileid : objectMain.ticket.files[i].idTicketAttachment
                },
                headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    console.log("Got file blob from database");
                    console.log(url);
                    //const link = document.createElement('a');
                    //link.href = url;
                    //link.setAttribute('download', 'file'+objectMain.ticket.files[i].idTicketAttachment+"."+objectMain.ticket.files[i].Extension); //or any other extension
                    //document.body.appendChild(link);
                    //link.click();
                    objectMain.ticket.files[i].imagePreview = url;
                    objectMain.ticket.files[i].showPreview = true;
                    objectMain.$forceUpdate(); 
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                // always executed
                console.log("Got image for file"+i);
                
                
            });
        }
      },
      clickedLink : function(idTicketAttachment,filename,filetype)
      {
          console.log("Clicked Link for "+idTicketAttachment);
          
          axios({
            url: localStorage.getItem('ticketCopURL') +'/getFile',
            method: 'GET',
            responseType: 'blob', // important  
            //axios.get('https://energydrive.dnsalias.com/ticketcop_dev/viewJobs', {
            params: {
                   fileid : idTicketAttachment
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename+"."+filetype); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
            // always executed
            console.log("Got all unresolved tickets for user");
            
            
            });
      },
      unresolve : function(){
          var idTicket = this.idTicket;
          
            var mainObject = this;
            mainObject.$swal({
            title: 'Are you sure you want to unresolve ticket#'+idTicket+' ?',
            //text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
            }).then((result) => {
            if (result.value) {
                console.log("Unresolve " + idTicket);
                let idemployee =  localStorage.getItem('idemployee');
                let employee =  localStorage.getItem('employee');
                axios.get(localStorage.getItem('ticketCopURL') +'/unresolve', {
                params: {
                        idTicket : idTicket,
                        employee : employee,
                        idemployee : idemployee
                },
                 headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                //console.log(response);
                    if ( response.data.status != "error" )
                    {
                        let text = "Ticket "+idTicket+" was succesfully unresolved";
                        mainObject.showAlert(text,2000,false);
                        mainObject.ticket.Resolved = false;
                        
                    }
                    else
                    {
                        //bootbox.alert("Error could not unresolve ticket "+idTicket, function() {});
                        let text = "Error could not unresolve ticket";
                        mainObject.showAlert(text,2000,false);
                        //mainobject.ticket.Resolved = false;

                    }
                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function (error) {
                    if ( error ) console.log(error);
                
                })
                .then(function () {
                // always executed
                 console.log("Unresolved ticket function called");
                
                }); 
            }
            })
        
						
            
      },
      updateEmployeeTagged : function(e)
      {
          let mainObject = this;
          this.ListEmployeeTagged = e;
          console.log("Calling updateEmployeeTagged")
          console.log(mainObject.employeeTagged);
          console.log(mainObject);
          axios.get(localStorage.getItem('ticketCopURL') +'/cleanAndAddEmployeesTAgged', {
                params: {
                    idTicket : mainObject.idTicket,
                    ListEmployeeTagged : mainObject.employeeTagged
                },
                headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                    console.log(response);
                
                })
                .catch(function (error) {
                console.log(error);
                })
                .then(function () {
                // always executed
                
            });// end of axios call

      },
		
      showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
     

      
      
  },
  prompt : function ()
      {
        let mainObject = this;
         mainObject.$swal({
        title: 'Are you sure?',
        //text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
        }).then((result) => {
        if (result.value) {
            return true;
        }
        else
            return false;
        })
     

      
      
  }
  },
  created: function () {
      this.baseURL = localStorage.getItem('ticketCopURL');
      this.ticketLink = "https://energydrive.dnsalias.com/ticketcop/viewTicket/"+this.idTicket
      // Get list of subscribers
      let objectMain = this;
      axios.get(localStorage.getItem('ticketCopURL') +'/getTicketSubscribers', {
          params: {
              idTicket : objectMain.idTicket,
           
          },
           headers: {"Authorization" : ("Bearer "+localStorage.getItem('jwt')) }
        })
        .then(function (response) {
            console.log("getTicketSubscribers");
            console.log(response);
         // console.log(response.data);
         
          objectMain.employeeTagged = response.data;
           objectMain.showListEmployeesTagged = true
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call
    
   
    
  },
  computed : {
      ticketState : function()
    {
        let returnval = "";
        switch(true)
        {
            case ((this.ticket.isJob)&&(this.ticket.Resolved) ) : returnval = "Job"; break;
            case ((this.ticket.isJob)&&(!this.ticket.Resolved) ) : returnval = "UNR Job"; break;
            default : returnval = "Ticket"; break;
        }
        return returnval
    }
  }/*,
  watch: {
    employeeTagged: function (val) {
        let mainObject = this;
        if ( this.showListEmployeesTagged )
        {
            // clear and add in database
            console.log("Value changed !");
            console.log(val);
            
            
        }

    }
  }*/
  
  
};
</script>



